import { forwardRef } from "react";
import type { HTMLAttributes } from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "../../lib/utils";
import { itemVariants, type ItemProps } from "./styles";

const Item = forwardRef<HTMLDivElement, ItemProps>(
  ({ className, variant, size, clickable = false, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "div";
    return <Comp ref={ref} className={cn(itemVariants({ variant, size, clickable, className }))} {...props} />;
  }
);
Item.displayName = "Item";

const ItemGroup = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => {
  return <div ref={ref} className={cn("flex flex-col gap-0", className)} {...props} />;
});
ItemGroup.displayName = "ItemGroup";

export { Item, ItemGroup };
